// Use a TypeScript version of gatsby-browser.js.
module.exports = require("./gatsby-browser.tsx")
